var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstituicaoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_2099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 34.6135C27.9411 34.6135 36 27.0023 36 17.6135C36 8.22462 27.9411 0.613464 18 0.613464C8.05887 0.613464 0 8.22462 0 17.6135C0 27.0023 8.05887 34.6135 18 34.6135Z",
    fill: "#7498CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.8345 19.92L22.856 7.66249H18V34.6135C27.1128 34.6135 34.6425 28.2177 35.8345 19.92Z",
    fill: "#000813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1967 5.79482H16.7873C13.6189 5.79482 11.0505 9.7764 11.0505 12.6051C11.0505 12.6051 8.28499 22.4143 9.18654 24.9086H26.7975C27.699 22.4143 24.9335 12.6051 24.9335 12.6051C24.9335 9.77633 22.3651 5.79482 19.1967 5.79482Z",
    fill: "#0F1928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5904 24.5319C19.3562 24.5319 20.524 22.1076 20.1688 19.6803H15.8311C15.476 22.1076 16.6437 24.5319 11.4095 24.5319C8.06448 24.5319 6.9231 25.9163 6.9231 28.9618V31.0138C9.97754 33.269 13.8224 34.6135 18 34.6135C22.1776 34.6135 26.0224 33.2691 29.0768 31.0138V28.9618C29.0768 25.9162 27.9355 24.5319 24.5904 24.5319Z",
    fill: "#FFD0AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.2455 21.0881C20.2341 20.6721 20.2189 20.2428 20.1561 19.8131H15.8182C15.7557 20.2407 15.7404 20.6682 15.729 21.0824C16.3566 21.4623 17.1028 21.6906 17.992 21.6906C18.8766 21.6906 19.6197 21.4646 20.2455 21.0881Z",
    fill: "#000813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5904 24.5319L20.7288 25.0731L17.987 24.9124L15.255 25.0731L11.4095 24.5319C8.06448 24.5319 6.9231 25.9163 6.9231 28.9618V31.0138C9.97754 33.269 13.8224 34.6135 18 34.6135C22.1776 34.6135 26.0224 33.2691 29.0768 31.0138V28.9618C29.0768 25.9162 27.9355 24.5319 24.5904 24.5319Z",
    fill: "#E4ED80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2102 24.9428H15.7642L17.3037 26.854L16.8918 34.5834C17.2426 34.6026 17.5957 34.6135 17.9517 34.6135C18.3315 34.6135 18.7083 34.601 19.0823 34.5791L18.6706 26.854L20.2102 24.9428Z",
    fill: "#0F1928"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.3037 26.854H18.6706C18.6706 26.854 18.3236 26.9715 17.9871 26.9715C17.6507 26.9715 17.3037 26.854 17.3037 26.854Z",
    fill: "#000813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5903 24.5319L20.7287 25.0731L17.9919 33.5289L15.255 25.0731L11.4095 24.5319C8.06448 24.5319 6.9231 25.9163 6.9231 28.9618V31.0138C9.97747 33.269 13.8223 34.6135 17.9999 34.6135C22.1775 34.6135 26.0224 33.2691 29.0767 31.0138V28.9618C29.0767 25.9162 27.9354 24.5319 24.5903 24.5319Z",
    fill: "#4075C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5598 22.6724H15.2265L13.1182 24.3907L15.3809 27.416L17.987 24.9124L15.5598 22.6724ZM20.4215 22.6724H20.7476L22.8559 24.3907L20.5932 27.416L17.987 24.9124L20.4215 22.6724Z",
    fill: "#E4ED80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7268 16.5316C13.2627 16.5316 13.6971 16.0479 13.6971 15.4513C13.6971 14.8546 13.2627 14.3709 12.7268 14.3709C12.191 14.3709 11.7566 14.8546 11.7566 15.4513C11.7566 16.0479 12.191 16.5316 12.7268 16.5316Z",
    fill: "#FFD0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2571 16.5316C23.793 16.5316 24.2273 16.0479 24.2273 15.4513C24.2273 14.8546 23.793 14.3709 23.2571 14.3709C22.7213 14.3709 22.2869 14.8546 22.2869 15.4513C22.2869 16.0479 22.7213 16.5316 23.2571 16.5316Z",
    fill: "#FFD0AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.3809 27.6812L17.9869 25.1107L20.5931 27.6812L23.0658 24.4457L23.0641 24.4453C22.9872 24.4353 22.9117 24.4247 22.839 24.4131L20.5931 27.416L17.987 24.9124L15.381 27.416L13.1351 24.4131C13.0623 24.4248 12.9869 24.4353 12.91 24.4453L12.9082 24.4457L15.3809 27.6812Z",
    fill: "#000813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6434 23.1478L11.3967 24.5319L14.154 26.854L12.7947 27.6812L17.992 33.5288L14.6434 23.1478ZM21.3407 23.1478L24.5874 24.5319L21.83 26.854L23.1895 27.6812L17.992 33.5288L21.3407 23.1478Z",
    fill: "#E4ED80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.5894 24.5319L21.8242 26.8541L22.0073 26.9655L24.8475 24.5354C24.7627 24.5334 24.6772 24.5319 24.5894 24.5319ZM11.3711 24.5319L14.1364 26.8541L13.9533 26.9655L11.113 24.5354C11.1978 24.5334 11.2833 24.5319 11.3711 24.5319ZM23.0362 27.8536L17.9921 33.5289L12.9479 27.8536L12.7947 27.9468L17.9921 33.8118L23.1895 27.9468L23.0362 27.8536Z",
    fill: "#000813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9567 7.68739H17.027C14.4895 7.68739 12.4324 10.498 12.4324 12.8946C12.4324 12.8946 12.5809 21.313 17.9918 21.313C23.4027 21.313 23.5513 12.8946 23.5513 12.8946C23.5514 10.498 21.4943 7.68739 18.9567 7.68739Z",
    fill: "#FFD0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9921 7.11185C13.097 7.11185 11.5987 11.4088 12.5633 14.3863C12.5633 14.3863 13.3068 13.8107 14.8095 13.4185C14.8095 13.4185 14.7149 12.2581 15.0294 10.7073C14.9854 12.1807 15.3127 13.3 15.3127 13.3C16.0556 13.1433 16.9488 13.0332 17.9921 13.0332C21.6162 13.0332 23.4207 14.3864 23.4207 14.3864C24.3854 11.4089 22.8871 7.11185 17.9921 7.11185Z",
    fill: "#0F1928"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.9921 13.0332C16.9627 13.0332 16.0802 13.1405 15.3431 13.294C15.3814 13.4637 15.4089 13.5579 15.4089 13.5579C16.1763 13.396 17.0988 13.2824 18.1763 13.2824C20.9563 13.2824 22.7074 13.9897 23.4207 14.3864C23.4179 14.4072 23.4236 14.3653 23.4207 14.3864C23.4189 14.3851 21.6145 13.0332 17.9921 13.0332ZM15.0323 11.3404C15.0242 11.1295 15.0232 10.9184 15.0294 10.7074C14.7148 12.2582 14.8095 13.4186 14.8095 13.4186C13.3086 13.8102 12.5653 14.3849 12.5634 14.3863C12.5494 14.2939 12.5753 14.4736 12.5634 14.3863C12.7245 14.2716 13.5447 13.9446 14.8892 13.6804C14.8892 13.6804 14.8099 12.706 15.0323 11.3404ZM21.7344 31.4558H25.0938V31.6063H21.7344V31.4558ZM10.9062 31.4558H14.2657V31.6063H10.9062V31.4558Z",
    fill: "#000813"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_2099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    fill: "white",
    transform: "translate(0 0.613464)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstituicaoIcon);
export default __webpack_public_path__ + "static/media/InstituicaoIcon.f3dc0bac90ce75184fbab6befd1492c4.svg";
export { ForwardRef as ReactComponent };